import Image from 'next/image'

export const BaseImage = ({
  className,
  src,
  alt = '',
  next = false,
  height = 'auto',
  width = 'auto',
  scale = false,
  sources = [],
  priority = false,
  fontSize = 'unset',
  pictureSx = {},
  sx,
  ...props
}) => {
  if (next) {
    const isSvg = typeof src === 'string' && src.endsWith('.svg')
    const style = {
      width: scale ? '100%' : width !== 'auto' ? width : 'auto',
      height: 'auto',
      maxWidth: width !== 'auto' ? width : 'unset',
      ...sx,
    }
    return (
      <Image
        className={className}
        src={src}
        alt={alt}
        width={0}
        height={0}
        sizes={scale ? '100vw' : width !== 'auto' ? width : '100vw'}
        unoptimized={isSvg}
        style={style}
        {...props}
      />
    )
  }
  return (
    <picture style={{ fontSize, ...pictureSx }}>
      {sources}
      <img
        className={className}
        style={{
          maxWidth: width === 'auto' ? 'unset' : width,
          ...(height !== 'auto' && { height: 'auto' }),
          ...sx,
        }}
        width={scale ? '100%' : (width !== 'auto' ? width : undefined)}
        height={height !== 'auto' ? height : undefined}
        src={src}
        alt={alt}
        fetchPriority={priority ? 'high' : undefined}
        {...props}
      />
    </picture>
  )
}
